import { criarSessao } from "@mtc/ui";

/** O que o backend devolve em GET /v1/admin/eu. */
export type Operador = { id: string; nome: string; email: string; role: "OWNER" | "ADMIN" | "SUPORTE" | "ANALISTA" };
export const PAPEL: Record<Operador["role"], string> = { OWNER: "Owner", ADMIN: "Admin", SUPORTE: "Suporte", ANALISTA: "Analista" };

export const { ProvedorSessao, useSessao } = criarSessao<Operador>({ renovar: "/v1/auth/admin/renovar", sair: "/v1/auth/admin/sair", eu: "/v1/admin/eu" });
